import axios from 'axios';

//const getToken = () => localStorage.getItem('token');
// console.log('getToken:', getToken());
// console.log('API URL:', process.env.VUE_APP_API_URL);
// console.log('Test Variable:', process.env.VUE_APP_TEST_VAR);
const hostapi = process.env.VUE_APP_API_URL+'/';




export const fetchGetOrderReceipt = async ({ receipt_code, store_code }) => {
  const ApiUrl = hostapi + 'RequestOrder/GetOrderRequest';
  
  const body = {
    receipt_code,
    store_code
  };
  
  try {
    const response = await axios.post(ApiUrl, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : 'fetchGetOrderReceipt Error';
  }
};


export const fetchGetOrderReceiptItem = async ({ receipt_code, store_code }) => {
  const ApiUrl = hostapi + 'RequestOrder/GetReceiptItemRequest';
  
  const body = {
    receipt_code,
    store_code
  };
  
  try {
    const response = await axios.post(ApiUrl, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : 'fetchGetOrderReceipt Error';
  }
};


export const CreateInvoiceRequest = async (payload) => {
  const ApiUrl = hostapi + 'EtaxInvoiceRequest/CreateEtaxInvoice';

  try {
    const response = await axios.post(ApiUrl, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : 'CreateInvoiceRequest Error';
  }
};


export const RequestOtpEmail = async (payload) => {
  const ApiUrl = hostapi + 'Email/SendOtp';

  try {
    const response = await axios.post(ApiUrl, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : 'RequestOtpEmail Error';
  }
};


export const ConfirmOtpToken = async (payload) => {
  const ApiUrl = hostapi + 'Email/VerifyOtp';

  try {
    const response = await axios.post(ApiUrl, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : 'ConfirmOtpToken Error';
  }
};


export const ResendOtpToken = async (payload) => {
  const ApiUrl = hostapi + 'Email/ResendOtp';

  try {
    const response = await axios.post(ApiUrl, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : 'ResendOtpToken Error';
  }
};

